@keyframes stagger-item-translate {
  from {
    translate: 0 7px;
  }

  to {
    translate: 0 0;
  }
}

@keyframes stagger-item-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes stagger-item-scale {
  from {
    scale: 1.05;
  }

  to {
    scale: 1;
  }
}

.item {
  --stagger-step: 100ms;
  --stagger-max-index: 6;
  /* Entrances start just before the footer slide ends. */
  --stagger-content-delay: 250ms;
}

.card {
  animation: stagger-item-translate 800ms cubic-bezier(0.25, 0, 0.1, 1) both,
    stagger-item-fade 150ms cubic-bezier(0.14, 0.66, 0.43, 1) both,
    stagger-item-scale 266ms cubic-bezier(0.15, 0.79, 0.27, 1) both;
}

.fade {
  animation: stagger-item-fade 300ms cubic-bezier(0.14, 0.66, 0.43, 1) both;
}

/* After the shorthands above, which would otherwise reset the delay. */
.card,
.fade {
  animation-delay: calc(
    min(var(--stagger-index, 0), var(--stagger-max-index)) * var(--stagger-step) + var(--stagger-content-delay)
  );
}

@media (prefers-reduced-motion: reduce) {
  .card,
  .fade {
    animation: none;
  }
}

:root[data-flyui-skip-animations="true"] .card,
:root[data-flyui-skip-animations="true"] .fade {
  animation: none;
}

.item.skip {
  animation: none;
}
